export default "__VITE_ASSET__XVfN3LIS__"